export default {
  LIST_FETCHED: 'BENEFITS_FETCHED',
  LIST_LOAD: 'BENEFITS_LOAD',
  ITEM_DETAIL: 'BENEFITS_DETAIL',
  BUTTON_LOAD: 'BENEFITS_BUTTON_LOAD',
};
